import { render, staticRenderFns } from "./BeenReturnedTable.vue?vue&type=template&id=5618f831&scoped=true"
import script from "./BeenReturnedTable.vue?vue&type=script&lang=js"
export * from "./BeenReturnedTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5618f831",
  null
  
)

export default component.exports